import { JSX, ReactNode } from "react";
import { handleReview } from "../../../pages/reviewPage/utils/handleReview";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { PostActionType, Refetch } from "../../../common/types/Types";

interface FormWrapperComponentProps {
    refetch: Refetch;
    patchCertificate: PostActionType;
    children: ReactNode;
}

export const FormWrapperComponent = (
    props: FormWrapperComponentProps,
): JSX.Element => {
    const dispatch = useAppDispatch();
    const { refetch, patchCertificate, children } = props;
    const { formValues, selectedCertificate } = useAppSelector(
        (state) => state.rejectCertificateModal,
    );

    return (
        <form
            className={"c-reject-certificate-modal__form"}
            onSubmit={(event) => {
                event.preventDefault();
                handleReview({
                    dispatch,
                    certificate: selectedCertificate,
                    review: false,
                    comment: formValues?.comment || "",
                    refetch,
                    patchCertificate,
                });
            }}
        >
            {children}
        </form>
    );
};
